import { Skeleton, Stack } from "@mantine/core";

/**
 * A loading placeholder for a table view — a stack of skeleton rows. Carries a
 * `role="status"` + `aria-label` so screen readers (and tests) can announce the
 * loading state, replacing a bare spinner with layout-stable shimmer.
 */
export function TableSkeleton({
  rows = 6,
  label,
}: {
  rows?: number;
  label: string;
}): JSX.Element {
  return (
    <Stack gap="xs" role="status" aria-label={label}>
      {Array.from({ length: rows }).map((_, i) => (
        <Skeleton key={i} height={28} radius="sm" />
      ))}
    </Stack>
  );
}
